/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useEffect } from 'react';
import { useAssetImages } from 'sarsaparilla';

// Inserts a <link rel="preload" as="image" fetchpriority="high"> for the
// facility hero so the browser can fetch it in parallel with the JS chunk
// and downstream APIs, instead of waiting for the lazy variant to mount.
export function useHeroImagePreload(facilityId: string | undefined) {
    const { heroImage, galleryImages } = useAssetImages({ assetId: facilityId });
    const previewUrl = heroImage?.url ?? galleryImages?.[0]?.url;

    useEffect(() => {
        if (!previewUrl) return;

        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = previewUrl;
        link.setAttribute('fetchpriority', 'high');
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, [previewUrl]);
}
